import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FileInput from '../../../components/fields/FileInput/FileInput';
import {
  showSignPopup, signDocx, signPDF, uploadSignFile, uploadUnsignedFile,
} from '../../System/actions';
import { getResponseError, nameBySave } from '../../../utils/utils';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { dateFormatter } from '../../../utils/formatters';
import { getSystemData } from '../../System/reducer';
import TimerLoader from '../../../components/base/Loader/TimerLoader';

export default function ImportSignDocument(props) {
  const {
    handleClose = () => {},
    loadData = () => {},
    loadById = () => {},
    loadDocuments = () => {},
    document,
  } = props;
  const { loadingUploadUnsignedFile, loadingUploadSignFile } = useSelector(getSystemData);
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const [sign, setSign] = useState(null);

  const handleSign = () => {
    if (!file || !file.length || !sign || !sign.length) { return; }
    const templateName = document && document.notification_template && document.notification_template.name
      ? document.notification_template.name
      : document.id;
    const name = nameBySave(`${templateName} № ${document.number} от ${dateFormatter(document.created_at)}.pdf`);

    const data = new FormData();
    data.append('model_type', 'document');
    data.append('model_id', document.id);
    data.append('collection_name', 'signed');
    data.append('name', name);
    data.append('file', file[0], nameBySave(name));
    data.append('sign_file', sign[0], nameBySave(`${name}.sig`));

    dispatch(uploadSignFile(data))
      .then(() => {
        successNotification('Импорт документа', 'Импорт документа прошел успешно');
        loadData();
        loadById(document.id);
        loadDocuments();
      })
      .catch(response => {
        errorNotification('Импорт документа', getResponseError(response));
      });
  };

  const handleSignPdf = () => {
    if (!file || !file.length) { return; }
    dispatch(showSignPopup()).then(cert => {
      if (file?.[0]?.type === 'application/pdf') {
        dispatch(signPDF({ cert, document, file }))
          .then(() => {
            successNotification('Импорт документа', 'Импорт документа прошел успешно');
            loadData();
            loadById(document.id);
            loadDocuments();
          })
          .catch(response => {
            errorNotification('Импорт документа', getResponseError(response, 'Ошибка подписания файла'));
          });
      } else {
        dispatch(signDocx({ cert, document, file }))
          .then(() => {
            successNotification('Импорт документа', 'Импорт документа прошел успешно');
            loadData();
            loadById(document.id);
            loadDocuments();
          })
          .catch(response => {
            errorNotification('Импорт документа', getResponseError(response, 'Ошибка подписания файла'));
          });
      }
    }).catch(() => {});
  };

  const handleUploadPdf = () => {
    if (!file || !file.length) { return; }
    const templateName = document && document.notification_template && document.notification_template.name
      ? document.notification_template.name
      : document.id;
    const name = nameBySave(`${templateName} № ${document.number} от ${dateFormatter(document.created_at)}.pdf`);
    const data = new FormData();
    data.append('model_type', 'document');
    data.append('model_id', document.id);
    data.append('collection_name', 'unsigned');
    data.append('name', name);
    data.append('file', file[0], name);
    dispatch(uploadUnsignedFile(data))
      .then(() => {
        successNotification('Импорт документа', 'Импорт документа прошел успешно');
        loadData();
        loadById(document.id);
        loadDocuments();
      })
      .catch(response => {
        errorNotification('Импорт документа', getResponseError(response, 'Ошибка подписания файла'));
      });
  };

  return (
    <Dialog
      onClose={handleClose}
      open
      className="import-document"
    >
      <DialogTitle
        header="Импорт документа"
        title={<Icons onClick={handleClose} customIcon icon="close" className="close" />}
      />
      <DialogContent>
        <TimerLoader global loading={loadingUploadUnsignedFile || loadingUploadSignFile} />
        <FileInput type="text" variant="material" label="Документ" inputProps={{ onChange: f => setFile(f) }} />
        <FileInput type="text" variant="material" label="Подпись документа" className="mt-3" inputProps={{ onChange: f => setSign(f) }} />
      </DialogContent>
      <DialogFooter className="modal-buttons">
        <Button className="download-button px-3" disabled={!file} onClick={handleUploadPdf}>Загрузить</Button>
        <Button className="download-button px-3" disabled={!file} onClick={handleSignPdf}>Загрузить и подписать</Button>
        <Button className="download-button" disabled={!file || !sign} onClick={handleSign}>Загрузить документ с подписью</Button>
      </DialogFooter>
    </Dialog>
  );
}
